import React from 'react';
import { MapPinIcon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/solid';

const Iletisim = () => {
  return (
    <div className="px-6 md:px-16 py-20 space-y-12" style={{ backgroundImage: "url('/background.png')" }}>
      <h1 className="text-3xl font-bold text-[#a03838] mb-6">İletişim</h1>

      <div className="space-y-8">
        <h2 className="text-2xl font-semibold text-gray-800 border-b pb-2 border-gray-200">Adres</h2>

        <ul className="space-y-4 text-gray-700">
          <li className="flex items-start gap-3">
            <MapPinIcon className="w-6 h-6 text-[#a03838]" />
            <span>Merkez Gökçebelen Köyü, Mersin</span>
          </li>
          <li className="flex items-start gap-3">
            <EnvelopeIcon className="w-6 h-6 text-[#a03838]" />
            <span>info@guneygelisim.k12.tr</span>
          </li>
          <li className="flex items-start gap-3">
            <PhoneIcon className="w-6 h-6 text-[#a03838]" />
            <span>0 324 473 25 34 – 36</span>
          </li>
        </ul>
      </div>

      {/* Google Harita */}
      <div className="mt-10">
        <iframe
            title="Güney Gelişim Koleji Harita"
            src="https://www.google.com/maps?q=South+Development+Schools,+G%C3%B6k%C3%A7ebelen+Mh.,+29+CAD.+NO:4%2FABC,+33115+YEN%C4%B0%C5%9EEH%C4%B0R%2FMersin&output=embed"
            width="100%"
            height="400"
            allowFullScreen=""
            loading="lazy"
            className="rounded-md shadow"
        ></iframe>
      </div>
    </div>
  );
};

export default Iletisim;
